import { GUEST_MONKEY_POST_AUTH_PATH } from '../../create/constants/guestMonkeyMirage.constants';
import { buildPublicSignInHref } from '../../signIn/helpers/postAuthRedirect.helper';

/** Create-account entry (same URL as sign-in) that returns to the Arena after auth. */
export function buildGuestSignUpHref(returnUrl: string = GUEST_MONKEY_POST_AUTH_PATH): string {
  return buildPublicSignInHref({ signup: true, returnUrl });
}
